import { Link, NavLink, useParams } from "react-router-dom";

export function AdminExpansionNav({ active = "dashboard" }) {
  const items = [
    { key: "dashboard", label: "Resumen", href: "/admin/expansion" },
    { key: "cities", label: "Ciudades", href: "/admin/expansion/cities" },
  ];
  return (
    <nav className="admin-console__nav-tabs">
      {items.map((item) => (
        <NavLink key={item.key} to={item.href} end={item.key === "dashboard"} className={({ isActive }) => (isActive || active === item.key ? "is-active" : undefined)}>
          {item.label}
        </NavLink>
      ))}
      <Link to="/admin/analytics/cities">Analytics ciudades</Link>
      <Link to="/admin/playbook/city-expansion">Playbook</Link>
    </nav>
  );
}

export function CityExpansionNav({ citySlug, active }) {
  const base = `/admin/expansion/cities/${citySlug}`;
  const items = [
    { key: "detail", label: "Resumen", href: base },
    { key: "readiness", label: "Readiness", href: `${base}/readiness` },
    { key: "dealers", label: "Dealers", href: `${base}/dealers` },
    { key: "inventory", label: "Inventario", href: `${base}/inventory` },
    { key: "seo", label: "SEO", href: `${base}/seo` },
    { key: "campaigns", label: "Campañas", href: `${base}/campaigns` },
    { key: "placements", label: "Placements", href: `${base}/placements` },
    { key: "analytics", label: "Analytics", href: `${base}/analytics` },
  ];
  return (
    <nav className="admin-console__nav-tabs">
      {items.map((item) => (
        <NavLink key={item.key} to={item.href} end={item.key === "detail"} className={({ isActive }) => (isActive || active === item.key ? "is-active" : undefined)}>
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}

export function CityPageShell({ citySlug, active, title, children }) {
  return (
    <>
      <CityExpansionNav citySlug={citySlug} active={active} />
      {title ? <h2 style={{ marginTop: "1rem" }}>{title}</h2> : null}
      {children}
    </>
  );
}

export function useCitySlugParam() {
  const { citySlug } = useParams();
  return citySlug;
}
